"use client"

import PrivacyAlert from "@/components/privacy-button"

export default function PageClient() {
  const handleClick = () => {
    window.open(
      "https://docs.google.com/document/d/1HU3_1WpaM-WHoObftj1i1GPsHDDKcLzTPP47urgc8LY/edit?tab=t.0",
      "_blank"
    )
  }
  const handleTwoClick = () => {
    window.open(
      "https://docs.google.com/document/d/1prRWnRLYtnIIeCkAPYTImvt7Qv7oQOaywhLBqv675L0/edit?tab=t.0",
      "_blank"
    )
  }
  return (
    <div className="relative">
      <div className="flex-col items-center px-3 pt-4 text-[#1D2129] sm:mb-14 sm:px-[120px] sm:pt-10">
        <div className="mb-2 text-[24px] font-bold sm:mb-5 sm:text-[36px]">
          SnapThePrice Rewards & Cashout FAQ
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          1. Who can participate in the SnapThePrice Rewards Program?
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          The SnapThePrice Rewards Program is available only to users located in
          the United States. Rewards and cash-out options apply exclusively to
          U.S. residents with valid U.S. PayPal accounts or Amazon Gift Card
          delivery addresses.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          2. How do I earn rewards as a new user?
        </div>
        <div className="mb-1 text-[14px]">
          There are two types of new user rewards:
        </div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            $5 Sign-Up Bonus: You receive $5 immediately after registering your
            account.
          </li>
          <li className="mb-1">
            $5 Installation Bonus: Once you install the SnapThePrice Chrome
            extension, you earn an additional $5 (marked as Pending). After
            completing 10 days of active usage, it becomes Payable.
          </li>
        </ul>
        <div className="mb-1 text-[14px]">
          Active usage means using SnapThePrice’s core functions daily — for
          example:
        </div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            Snapping a product to find the lowest price and viewing its details.
          </li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Chatting with the built-in AI Shopping Assistant (powered by
            ChatGPT)
          </li>
        </ul>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          3. How does the daily Snap reward work?
        </div>
        <div className="mb-1 text-[14px]">
          You earn $0.05 for every successful Snap (when you use the Snap
          function to find a product’s lowest price).
        </div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            You can Snap unlimited times per day, but only the first 20 Snaps
            per day are rewarded.
          </li>
          <li className="mb-1">
            This means you can earn up to $1.00 per day in payable rewards.
          </li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Daily Snap and reward data are updated the next day in your account
            dashboard.
          </li>
        </ul>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          4. How can I earn rewards by inviting friends?
        </div>
        <div className="mb-1 text-[14px]">
          You can find your personal referral link in the Rewards section of
          your account.
        </div>
        <div className="mb-1 text-[14px]">
          When someone registers using your link:
        </div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            Both you and the invited friend receive $5 Pending Rewards.
          </li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Once your friend completes 10 days of active use, both rewards
            become Payable.
          </li>
        </ul>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          5. When can I cash out my rewards?
        </div>
        <div className="mb-1 text-[14px]">
          Once your Available to Cash Out balance reaches $20, you can submit a
          withdrawal request directly on the Rewards Page.
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          After verification, our team will process your payment.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          6. What payment methods are available?
        </div>
        <div className="mb-1 text-[14px]">You can choose between:</div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            PayPal (U.S. accounts only) — direct cash transfer.
          </li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Amazon Gift Card — equivalent value to your cash rewards.
            <br />
            You can set your preferred redemption method on the Rewards Page.
          </li>
        </ul>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          7. Do my rewards ever expire?
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          No. Rewards earned through SnapThePrice never expire. You can redeem
          them anytime once your balance meets the $20 minimum requirement.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          8. How does SnapThePrice prevent fraud?
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          To ensure fairness, new users must complete 10 days of valid activity,
          where at least 70% of Snap/Chat interactions originate from U.S.-based
          IPs. Rewards that do not meet this condition are marked as invalid and
          non-redeemable.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          9. Can I have multiple accounts?
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          No. Each device ID is eligible for rewards only once. Creating
          multiple accounts from the same device will void all rewards except
          for the first registered account.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          10. What if my rewards are still pending?
        </div>
        <div className="mb-1 text-[14px]">
          Pending rewards are usually tied to:
        </div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">Your 10-day activity verification period.</li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Your friend’s referral activity completion.
            <br />
            Once these conditions are met, pending rewards will automatically
            convert to Payable within 24 hours.
          </li>
        </ul>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          11. What if I don’t see my rewards updated?
        </div>
        <div className="mb-2 text-[14px] sm:mb-5">
          Your Snap and reward data refresh the following day. If you still
          don’t see updates after 48 hours, please contact our support team at
          support@snaptheprice.com.
        </div>
        <div className="mb-1 text-[20px] font-bold sm:mb-2">
          12. How can I get help with cash-out or technical issues?
        </div>
        <div className="mb-1 text-[14px]">For any questions, please:</div>
        <ul className="list-disc pl-5 text-[14px]">
          <li className="mb-1">
            Visit our{" "}
            <span
              onClick={handleClick}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Rewards Policy
            </span>{" "}
            or{" "}
            <span
              onClick={handleTwoClick}
              className="cursor-pointer text-[#135BFF] underline"
            >
              Cashout Tutorial
            </span>
            , or
          </li>
          <li className="mb-2 text-[14px] sm:mb-5">
            Email us at support@snaptheprice.com.
            <br />
            We’ll respond as soon as possible.
          </li>
        </ul>
        <div className="text-[14px]">
          ⚠️Note: All rewards policies and terms are valid only within the
          United States and are subject to SnapThePrice’s final interpretation.
        </div>
      </div>
      <PrivacyAlert />
    </div>
  )
}
